import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Label,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation-safe";
import Select from "react-select";

import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { VoltarButton } from "../../../../components/ActionButton";
import api from "../../../../services/api";

import { useAguarde, useMessageBox } from "../../../../contexts/globalContext";

const EmpresaAtendimentoExibirPage = (props) => {
  const history = useHistory();

  const { setAguarde } = useAguarde();
  const { setMessageBox } = useMessageBox();

  const [registro, setRegistro] = useState([]);

  const [tiposAtendimentos, setTiposAtendimentos] = useState([]);
  const [tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado] = useState(
    []
  );

  const optionTipoAtendimento = [
    {
      options: tiposAtendimentos,
    },
  ];

  useEffect(() => {
    async function getTipoAtendimento() {
      try {
        const response = await api.get("/web/tipoatendimento");

        if (!response.data.success) {
          throw response.data;
        }

        const listaTipoAtendimento = response.data.data.map(
          (tipoAtendimento) => {
            return {
              label: tipoAtendimento.descricao,
              value: tipoAtendimento.tipoAtendimentoId,
            };
          }
        );

        setTiposAtendimentos(listaTipoAtendimento);
      } catch (err) {
        setTiposAtendimentos([]);
        setAguarde(false);
        await setMessageBox({
          show: true,
          title: "Erro",
          description: err.message,
          error: true,
        });
      }
    }
    getTipoAtendimento();
  }, [setAguarde, setMessageBox]);

  useEffect(() => {
    async function getAtendimentoEmpresa() {
      try {
        const values = queryString.parse(props.location.search);
        setAguarde(true);
        const response = await api.get(
          `/web/horarioatendimentoempresa/padrao/${values.id}`
        );
        setAguarde(false);

        if (!response.data.success) {
          throw response.data;
        }

        const tipoAtendimentoEmpresa = response.data.data;

        const auxTipoAtendimento = tiposAtendimentos.filter(
          (tipoAtendimento) =>
            tipoAtendimento.value === tipoAtendimentoEmpresa.tipoAtendimentoId
        );

        if (auxTipoAtendimento[0]) {
          setTipoAtendimentoSelecionado(auxTipoAtendimento[0]);
        }

        setRegistro(tipoAtendimentoEmpresa);
      } catch (err) {
        setRegistro([]);
        setAguarde(false);
        await setMessageBox({
          show: true,
          title: "Erro",
          description: err.message,
          error: true,
        });
      }
    }
    getAtendimentoEmpresa();
  }, [props.location.search, setAguarde, setMessageBox, tiposAtendimentos]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title="Horários de Atendimento - Visualização"
            breadcrumbItem="Horário de Atendimento"
          />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm className="form-horizontal">
                    <Row>
                      <Col sm="4">
                        <FormGroup>
                          <Label>Tipo de Atendimento</Label>
                          <Select
                            placeholder="Selecione um tipo de atendimento"
                            value={tipoAtendimentoSelecionado}
                            onChange={setTipoAtendimentoSelecionado}
                            options={optionTipoAtendimento}
                            classNamePrefix="select2-selection"
                            isDisabled={true}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="8">
                        <FormGroup>
                          <AvField
                            name="conta"
                            label="Horário"
                            value={registro.descricao}
                            className="form-control"
                            placeholder=""
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="text-sm-right">
                      <VoltarButton
                        goBack={() => {
                          history.goBack();
                        }}
                      />
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmpresaAtendimentoExibirPage;
